import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewTransactionListingComponent } from '../new-transaction-listing/new-transaction-listing.component';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { GoogleReviewModalComponent } from '../google-review-modal/google-review-modal.component';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-new-sub-admins-subscription',
  templateUrl: './new-sub-admins.component.html',
  styleUrls: ['./new-sub-admins.component.scss'],
})
export class NewSubAdminsSubscription implements OnInit {
 // subadmins: any;
 // year = moment().year();
 // currentYear = moment().year();
//  years: { id: string; name: string }[];
 // search: any;
//  google_feedbacks: any;
//  edit_google_review: any;
//  editFG: FormGroup;
//  edit_google_feedbacks: any;
//  url_names: any;
  transactions: any;
  total_txn: number = 0;
  currentDate: any;// new Date();
  timestamp: any;// = currentDate.getTime();
  timediff: any; 
  filteredTransactionsA: any ;
  filteredTransactionsB: any;
  tabis: number = 1;
  opacitytable: number = 0.6;

  productIdsA = ['prod_QNzkkGPAVuktz6', 'prod_QNx3lrjeIt3JIA'];

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) {}

  ngOnInit(): void { 
    this.vip_sub_transactions();
    this.currentDate = new Date();
    this.timestamp = this.currentDate.getTime();
    /*

    this.editFG = new FormGroup({
      feedbackNameId: new FormControl(''), // add default value
      description: new FormControl(''),
      star: new FormControl(''),
    });
    */
  }

  showdiff(at, d1, da) {
    if (at != 'active') {
      return 'InActive'; 
    }
    var date2: any = new Date(da);
    var date1: any = new Date(d1); 
    date1 = date1.getTime();
    date2 = date2.getTime();
    date2 = date2 * 1000;
    var diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
     
    diffDays += 1;
    if (diffDays < 0) {
      return 'Expired ';
    }
    return (diffDays  ) + ' Days Left'; // +1
  }
  vip_sub_transactions(options = 1) {
    this.opacitytable = 0.4;
    this.tabis = options;
    let option = 1;
    if (options > 1) {
      option = 2;
    }
    this.auth.vip_sub_transactions(option).subscribe((response: any) => {
      this.opacitytable = 1;
      this.transactions = response.body.transactions;
      if (options >= 2) {
        if (options == 3) {
          this.filteredTransactionsA = this.transactions.filter(i =>
            this.productIdsA.includes(i.plan.product)
          );
          this.transactions = this.filteredTransactionsA;
        }
       
        if (options == 2) { 
          this.filteredTransactionsB = this.transactions.filter(i =>
            !this.productIdsA.includes(i.plan.product)
          );
          this.transactions = this.filteredTransactionsB;
        }
        
      } 
      this.total_txn = response.body.available;
      /*forEach(this.transactions as i){ 
        this.timediff = (i.current_period_end - this.timestamp) / (1000 * 3600 * 24);
        console.log(this.timediff);
      }*/
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
 
   
  
}
